<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-organization-inn" class="col-form-label">{{ inputLabel }}</label>
    <template v-if="!isFizOrganizationSubject">
      <typeahead
        type="text"
        id="form-organization-inn"
        autocomplete="off"
        :disabled="disabled"
        v-model="inputValue"
        @change="emit"
        @blur="emit"
        @keyup.enter="emit"
        @keyup.delete="emit"
        @hit="selectTypeahead($event, true)"
        :data="data"
        :serializer="this.serializeData"
        :maxMatches="typeaheadLimit"
        :minMatchingChars='2'
        maxlength="12"
      >
        <template v-slot:suggestion="{data, htmlText}">
          <template v-if="data && data.isInn && data.unrestricted_value">
            <div>{{ data.unrestricted_value }}</div>
          </template>
          <template v-else>
            <div v-html="htmlText"></div>
          </template>

          <template v-if="data && data.data">
            <template v-if="data.isInn">
              <div v-html="htmlText"></div>
            </template>
            <template v-else>
              <div>{{ data.data.inn }}</div>
            </template>

            <div v-if="data.data.address">{{ data.data.address.value }}</div>
          </template>
        </template>
      </typeahead>
    </template>
    <template v-else>
      <input
        type="text"
        class="form-control"
        id="form-organization-inn"
        autocomplete="off"
        maxlength="12"
        :disabled="disabled"
        v-model="inputValue"
        @input="emit"
        @blur="emit"
        @change="emit"
        @keydown="emit"
        @keyup="emit"
      />
    </template>
    <div v-if="form.organization.innControlSumErr" class="form-fielderror trailer-error">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>Контрольные суммы не совпадают. Введите правильный ИНН.</div>
      </div>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationInnInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'ИНН'
    },

    inputName: {
      default: 'inn'
    }
  },

  data () {
    return {
      data: []
    }
  },

  methods: {
    serializeData (item) {
      let result = ''

      if (this.checkInn(item)) {
        result = item?.value
        item.isInn = true
      } else {
        result = item?.unrestricted_value
        item.isInn = false
      }

      return result
    },

    checkInn (item) {
      return item?.value && item?.value?.indexOf(this.inputValue) !== -1
    }
  }
}
</script>
